import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import { cryptoDecrypt } from '@/utils/aes';
import topTitle from '@/components/title';
import areaSelect from '@/components/cascader.vue';
import { uploadFile } from './../../customer/applicationManage/request';
import { mainPlanResource } from './../../insurance/insuranceManage/request';
import { applicationResource } from './../../customer/applicationManage/request';
import { insuranceResource } from './../../insurance/insuranceManage/request';
import { insuranceInfoMark } from './../../insurance/releaseManage/request';
import { customerResource } from './../../system/customerManage/request';
import { policyTempConfig } from './../homeManage/request';
import { planRelateData } from './request.js';
import { mapState } from 'vuex';
import { addPolicy, policyVerifyy } from './request';
import { getBase64 } from '@/utils/validate';
import PalnModel from './planModel.vue';
import { recursionCopy } from '@/views/customer/roleManage/utils';
import previewModal from '@/views/claim/demageManage/previewModal.vue';
import { isVideo, isImage } from '@/views/claim/demageManage/utils';
import moment from 'moment';
export default {
  components: {
    topTitle,
    areaSelect,
    PalnModel,
    previewModal
  },
  data() {
    return {
      action: uploadFile,
      form: {
        planId: undefined,
        insuranceId: undefined,
        premiumPrice: undefined,
        startAt: undefined,
        endAt: undefined,
        personnelDetails: false
      },
      insuranceInfo: {},
      productList: [],
      applicationList: [],
      isEdit: false,
      applicantForm: {},
      insuredForm: {},
      applicantInfo: {},
      applicantTypeTemOption: [],
      applicantList: [],
      insuredList: [],
      insuredTemplate: [],
      planList: [],
      customerList: [],
      fileList: [],
      palnShow: false,
      continueState: false,
      loading: false,
      previewVisible: false,
      previewSrc: '',
      isShow: '',
      isAreaPrice: false,
      //是否是区域保费
      rearOptions: [],
      //区域保费的下拉选择值
      priceMap: {},
      currentPreviewIndex: 0,
      hasAttachInfo: false,
      attachOptions: [],
      attachValue: [],
      tableData: [],
      columns: [{
        slots: {
          title: '产品名称'
        },
        dataIndex: 'name',
        key: 'name',
        width: '30%'
      }, {
        slots: {
          title: '保障额度'
        },
        dataIndex: 'amount',
        key: 'amount',
        width: '40%',
        scopedSlots: {
          customRender: 'amount'
        }
      }, {
        slots: {
          title: '保费'
        },
        dataIndex: 'price',
        key: 'price',
        width: '30%',
        scopedSlots: {
          customRender: 'price'
        }
      }],
      //附加险信息表头信息
      discountInfo: {},
      //折扣信息
      discountPrice: '-',
      discountData: [],
      areaCodeValue: []
    };
  },
  computed: {
    dataRule() {
      return {
        customerId: [{
          required: true,
          message: this.$t('请选择') + this.$t('保单归属'),
          trigger: 'change'
        }],
        policyNo: [{
          required: true,
          message: this.$t('请输入') + this.$t('保单号'),
          trigger: 'blur',
          transform: value => {
            return (value === null || value === void 0 ? void 0 : value.trim()) || '';
          }
        }, {
          min: 5,
          max: 200,
          trigger: 'blur',
          message: this.$t('最少输入5字符，最多输入200字符'),
          transform: value => {
            return (value === null || value === void 0 ? void 0 : value.trim()) || '';
          }
        }],
        applicationId: [{
          required: true,
          message: this.$t('请选择') + this.$t('保单来源'),
          trigger: 'change'
        }],
        insuranceId: [{
          required: true,
          message: this.$t('请选择') + this.$t('产品名称'),
          trigger: 'change'
        }],
        startAt: [{
          required: true,
          trigger: 'change',
          message: this.$t('请选择') + this.$t('生效日期')
        }],
        endAt: [{
          required: true,
          trigger: 'change',
          message: this.$t('请选择') + this.$t('终止日期')
        }],
        premiumPrice: [{
          required: true,
          message: this.$t('请输入') + this.$t('保费'),
          trigger: 'blur'
        }],
        planId: [{
          required: true,
          message: this.$t('请选择') + this.$t('保险方案'),
          trigger: 'change'
        }],
        policyUrl: [{
          required: true,
          type: 'array',
          validator: this.validateImg,
          trigger: 'change'
        }]
      };
    },
    ...mapState({
      accountInfo: state => state.user.accountInfo
    }),
    showRate() {
      //是否展示费率类型
      if (this.form.planId) {
        let arr = this.planList.filter(item => item.id === this.form.planId);
        if (arr && arr.length) {
          let duration = arr[0].duration;
          let reg = /^(\d)*天/;
          //保障期限为1年的并且配置了申报方式的才展示费率类型
          if (duration === '1年' && this.showPersonnelDetail || reg.test(duration) && this.showPersonnelDetail) {
            this.$set(this.form, 'personnelDetails', false);
            return true;
          } else {
            return false;
          }
        } else {
          return false;
        }
      } else {
        return false;
      }
    },
    showPersonnelDetail() {
      //是否展示人员明细
      if (this.form.insuranceId) {
        let arr = this.productList.filter(item => item.id == this.form.insuranceId);
        if (arr && arr.length && arr[0].declarationMethod) {
          this.$set(this.form, 'personnelDetails', false);
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    }
  },
  created() {
    if (this.accountInfo.tag == 0) {
      applicationResource({
        customerId: this.accountInfo.customerId,
        position: 'policy'
      }).then(res => {
        this.applicationList = res;
      });
    } else {
      customerResource({
        customerId: this.accountInfo.customerId,
        position: 'policy'
      }).then(res => {
        this.customerList = res;
      });
    }
  },
  watch: {
    'form.premiumPrice': {
      handler() {
        this.computedDiscountPrice();
        if (this.discountInfo && Object.keys(this.discountInfo).length) {
          this.$set(this.form, 'discountMode', this.discountInfo.discountMode);
          this.$set(this.form, 'discountRatio', this.discountInfo.discountRatio);
          this.$set(this.form, 'discountAmount', this.discountInfo.discountAmount);
        }
      }
    },
    attachValue: {
      handler(newVal, oldVal) {
        if ((oldVal && oldVal.length === 0 || !oldVal) && newVal.length !== 0) {
          this.$set(this.form, 'policyType', 1);
        }
        this.tableData = [];
        newVal && newVal.forEach(value => {
          let selectItem = this.attachOptions.filter(item => item.attachId === value);
          if (selectItem.length) {
            let item = selectItem[0];
            //默认选中第一个方案
            if (!item.attachPlan) {
              //保障额度一个都没有的情况
              item.attachPlanId = '-';
              item.price = '-';
              item.amount = '-';
            } else {
              var _item$attachPlan, _item$attachPlan2;
              item.attachPlanId = item.attachPlanId || ((_item$attachPlan = item.attachPlan) === null || _item$attachPlan === void 0 || (_item$attachPlan = _item$attachPlan[0]) === null || _item$attachPlan === void 0 ? void 0 : _item$attachPlan.id) || '-';
              item.price = item.price || ((_item$attachPlan2 = item.attachPlan) === null || _item$attachPlan2 === void 0 || (_item$attachPlan2 = _item$attachPlan2[0]) === null || _item$attachPlan2 === void 0 ? void 0 : _item$attachPlan2.price) || '-';
              if (item.attachPlan.length === 1) {
                //只有一个方案的直接保障额度使用文本展示
                item.amount = item.amount || item.attachPlan[0].amount;
              }
            }
            this.tableData.push(item);
          }
        });
      }
    }
  },
  methods: {
    validateImg(rule, value, callback) {
      if (this.fileList.length == 0) {
        callback(new Error(this.$t('请上传电子保单')));
      } else {
        callback();
      }
    },
    resetInfo() {
      this.attachInfo = []; //附加险信息清空
      this.hasAttachInfo = false; //清空附加险信息
      this.isAreaPrice = false; //区域保费信息清空
      this.rearOptions = []; //区域保费信息清空
      this.applicantInfo = {}; //投保人的模板信息
      this.form.startAt = '';
      this.form.endAt = '';
      this.areaCodeValue = [];
      this.form.areaCode = ''; //区域保费的区域的code
      this.form.premiumPrice = ''; //保费
      this.applicantList = []; //清空投保人信息
      this.insuredList = []; //清空被投保人信息
      this.discountInfo = {}; //清空折扣信息
      this.discountData = [];
      this.tableData = []; //清空已选择的附加险方案信息
      this.attachValue = []; //清空已选择的附加险
      this.isEdit = false; //控制不展示干系人信息
    },
    getErrorMessage(item) {
      //区分校验的报错信息
      if (item.display === 'text') {
        return this.$t('请填写') + item.name;
      } else {
        return this.$t('请选择') + item.name;
      }
    },
    asyncValue(e, obj, key, type) {
      if (type === 'select') {
        this.$set(obj, key, e);
      } else {
        this.$set(obj, key, e.target.value);
      }
      this.$delete(obj, 'checkResult');
    },
    amountSelect(value, record) {
      let attachPLan = record.attachPlan && Array.isArray(record.attachPlan) && record.attachPlan.filter(item => item.id === value);
      if (attachPLan.length) {
        this.$set(record, 'price', attachPLan[0].price);
        this.$set(record, 'attachPlanId', value);
        this.tableData = [...this.tableData];
      }
    },
    timeChange(value) {
      //通过生效日期计算终止日期
      if (!value) {
        this.form.endAt = '';
        this.$refs.dataFrom.validateField('endAt');
        return;
      }
      let arr = this.planList.filter(item => item.id === this.form.planId);
      if (!arr.length) return;
      let duration = arr[0].duration;
      if (!duration) return;
      let startTime;
      if (/-/.test(duration)) {
        duration = duration.split('-')[1];
      }
      if (/^[0-9]+年$/.test(duration)) {
        duration = Number.parseInt(duration);
        // startTime = new Date(value).getTime() + duration * 365 * 24 * 60 * 60 * 1000;
        startTime = moment(value).add(duration, 'years');
      }
      if (/^[0-9]+月$/.test(duration)) {
        duration = Number.parseInt(duration);
        startTime = new Date(value).getTime() + duration * 30 * 24 * 60 * 60 * 1000;
      }
      if (/^[0-9]+天$/.test(duration)) {
        duration = Number.parseInt(duration);
        startTime = new Date(value).getTime() + duration * 24 * 60 * 60 * 1000;
      }
      if (duration === this.$t('终身')) {
        startTime = new Date(value).getTime() + 100 * 365 * 24 * 60 * 60 * 1000;
      }
      this.form.endAt = moment(startTime).format('YYYY-MM-DD HH:mm:ss');
      this.form.startAt = moment(value).format('YYYY-MM-DD HH:mm:ss');
      this.$refs.dataFrom.validateField('endAt');
    },
    getPlanRelateData() {
      //根据保险方案获取干系人的相关信息以及折扣的信息
      if (!this.form.planId) {
        return;
      }
      const {
        customerId,
        structureId
      } = this.accountInfo;
      let params = {
        customerId,
        structureId,
        insuranceId: this.form.insuranceId,
        insurancePlanId: this.form.planId,
        applicationId: this.form.applicationId
      };
      this.applicantTypeTemOption = [];
      this.insuredTemplate = [];
      this.applicantForm && Object.keys(this.applicantForm).forEach(key => {
        this.applicantForm[key] = undefined;
      });
      this.insuredForm && Object.keys(this.insuredForm).forEach(key => {
        this.insuredForm[key] = undefined;
      });
      this.$delete(this.form, 'discountMode', this.discountInfo.discountMode);
      this.$delete(this.form, 'discountRatio', this.discountInfo.discountRatio);
      this.$delete(this.form, 'discountAmount', this.discountInfo.discountAmount);
      this.discountInfo = {};
      planRelateData(params).then(res => {
        if (res) {
          this.discountData = res.discountInfo;
          if (res.discountInfo && res.discountInfo.length === 0) {
            this.discountPrice = '-';
          } else {
            if (!this.isAreaPrice) {
              //没有折扣保费的时候后查找折扣信息中是否有areaIndex为0的折扣信息
              let info = this.discountData.filter(item => item.areaIndex === 0);
              this.discountInfo = info.length > 0 ? info[0] : {};
            }
            if (this.discountInfo && Object.keys(this.discountInfo).length > 0) {
              this.computedDiscountPrice();
              this.$set(this.form, 'discountMode', this.discountInfo.discountMode);
              this.$set(this.form, 'discountRatio', this.discountInfo.discountRatio);
              this.$set(this.form, 'discountAmount', this.discountInfo.discountAmount);
            }
          }
          let templateRenderList = res.templateRenderList;
          Array.isArray(templateRenderList) && templateRenderList.forEach(item => {
            if (item.code === 'applicant') {
              //投保人
              let applicantTypeInfo = item.item[0];
              let applicantInfo = [];
              if (applicantTypeInfo.inputKey === 'COMPANY') {
                applicantInfo = item.company;
              }
              if (applicantTypeInfo.inputKey === 'NATURAL_PERSON') {
                applicantInfo = item.personal;
              }
              this.applicantForm.applicantType = applicantTypeInfo.inputKey;
              this.applicantInfo = item; //投保人模板信息
              this.applicantTypeTemOption = applicantTypeInfo.value; //投保类型的选择模板数据
              this.applicantList = this.formatFormTemplate(applicantInfo); //处理后的投保人模板信息
              if (this.applicantList.length) {
                this.isEdit = true;
              }
            }
            if (item.code === 'insured') {
              //被投保人
              let arr = this.formatFormTemplate(item.item);
              this.insuredTemplate = item.item; //存储模板，有新增被投保人的时候使用
              this.insuredList.push(arr);
            }
          });
        }
      });
    },
    computedDiscountPrice() {
      if (!this.form.premiumPrice) {
        this.discountPrice = '-';
        return;
      }
      if (this.discountInfo && Object.keys(this.discountInfo).length > 0) {
        const num = this.discountInfo.discountMode === 'ratio' ? this.discountInfo.discountRatio : this.discountInfo.discountAmount;
        if (num <= 0) {
          this.discountPrice = '-';
          return;
        }
        if (this.discountInfo.discountMode == 'ratio' && num >= 100) {
          this.discountPrice = '-';
          return;
        }
        if (this.discountInfo.discountMode === 'ratio') {
          this.discountPrice = Number(Number(this.form.premiumPrice) * 100 - Number(this.form.premiumPrice) * 100 * Number(this.discountInfo.discountRatio / 100)) / 100;
        }
        if (this.discountInfo.discountMode === 'amount') {
          this.discountPrice = Number(Number(this.form.premiumPrice) * 100 - Number(this.discountInfo.discountAmount) * 100) / 100;
        }
        this.discountPrice = this.discountPrice > 0 ? parseFloat(this.discountPrice).toFixed(2) : 0;
      } else {
        this.discountPrice = '-';
      }
    },
    formatFormTemplate(data) {
      if (!Array.isArray(data)) {
        return [];
      }
      return data.map(item => {
        let obj = {
          code: item.code,
          display: item.display,
          id: item.id,
          name: item.name,
          type: item.type,
          valData: undefined,
          selectarr: [],
          required: item.isOptional === 0
        };
        if (item.display == 'dropDownBox' || item.display == 'profession' || item.display == 'dropDownBox(region.code)') {
          obj.selectarr = item.value;
        }
        return obj;
      });
    },
    areaChange(value, selectOption) {
      let key = value[value.length - 1];
      this.$set(this.form, 'areaCode', key);
      let areaIndex = selectOption[selectOption.length - 1].areaIndex;
      if (areaIndex) {
        //存在areaIndex代表该区域有折扣信息设置折扣信息
        let areaInfo = this.discountData.filter(item => item.areaIndex === areaIndex);
        this.discountInfo = areaInfo.length > 0 ? areaInfo[0] : {};
      }
      this.form.premiumPrice = this.priceMap[key];
      this.$refs.dataFrom.validateField('premiumPrice');
    },
    filterOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0;
    },
    applicationChange() {
      this.form.insuranceId = undefined;
      this.form.planId = undefined;
      this.insuranceInfo = {};
      let obj = {
        applicationId: this.form.applicationId,
        position: 'manualRecording'
      };
      if (this.accountInfo.tag != 0) {
        obj.customerId = this.form.customerId;
      }
      insuranceResource(obj).then(res => {
        this.productList = res;
      });
    },
    productChange() {
      //获取干系人信息
      if (!this.form.insuranceId) {
        //清空产品名称的时候也清空保险方案
        this.form.planId = undefined;
        this.insuranceInfo = {};
        return;
      }
      let arr = this.productList.filter(item => item.id == this.form.insuranceId);
      insuranceInfoMark({
        mark: arr[0].mark
      }).then(res => {
        this.insuranceInfo = res;
      });
      this.form.planId = undefined;
      mainPlanResource({
        insuranceId: this.form.insuranceId
      }).then(res => {
        this.planList = res.items.map(item => {
          item.rightsCont = JSON.parse(item.rights);
          return item;
        });
      });
    },
    planChange() {
      let arr = this.planList.filter(item => item.id === this.form.planId);
      this.resetInfo();
      if (arr.length) {
        let selectPlanInfo = arr[0];
        this.$set(this.form, 'wait', selectPlanInfo.duration);
        //是否是区域保费
        this.isAreaPrice = selectPlanInfo.priceType === 'AREA_PRICE' ? true : false;
        let defaultValue = selectPlanInfo.priceType === 'AREA_PRICE' ? undefined : selectPlanInfo.price;
        this.$set(this.form, 'premiumPrice', defaultValue);
        //区域保费得下拉选择数据
        this.priceMap = {};
        const formatShowArea = (data, price) => {
          const result = data.map(item => {
            let obj = {};
            if (item.city && item.city.length) {
              obj.children = formatShowArea(item.city, item.price);
            }
            this.priceMap[item.code] = price || item.price;
            obj.value = item.code;
            obj.label = item.name;
            obj.areaIndex = item.areaIndex;
            return obj;
          });
          return result;
        };
        let allShowArea = selectPlanInfo.allShowArea ? JSON.parse(selectPlanInfo.allShowArea) : [];
        this.rearOptions = formatShowArea(allShowArea);
        //附加险信息
        this.attachOptions = selectPlanInfo.attachInfo && JSON.parse(selectPlanInfo.attachInfo);
        if (this.attachOptions) {
          this.hasAttachInfo = true; //控制是否展示附加险信息
          this.attachOptions.forEach(item => {
            if (item.buyLimit === 1) {
              item.disabled = true;
              item.allowClear = false;
              this.attachValue.push(item.attachId);
            }
          });
        }
      }
      this.getPlanRelateData();
    },
    applicantChange() {
      const arr = this.applicantForm.applicantType === 'COMPANY' ? this.applicantInfo.company : this.applicantInfo.personal;
      // this.form.insuranceType = this.applicantForm.applicantType;
      this.applicantForm && Object.keys(this.applicantForm).forEach(key => {
        if (key !== 'applicantType') {
          this.$delete(this.applicantForm, key);
        }
      });
      this.applicantList = this.formatFormTemplate(arr);
      this.insuredList = [];
      this.insuredForm && Object.keys(this.insuredForm).forEach(key => {
        this.$delete(this.insuredForm, key);
      });
      this.addInsuredFun();
    },
    addInsuredFun() {
      //新增被保险人
      let arr = this.formatFormTemplate(this.insuredTemplate);
      this.insuredList.push(arr);
    },
    async getSelectInfo(type, item, index, index2) {
      if (item.display == 'dropDownBox' || item.display == 'profession' || item.display == 'dropDownBox(region.code)') {
        let res = await policyTempConfig({
          insuranceId: this.form.insuranceId,
          tempCode: item.code
        });
        if (type == 'applicant') {
          this.applicantList[index].selectarr = res;
        } else {
          this.insuredList[index][index2].selectarr = res;
        }
      }
    },
    checkForm(form) {
      let result = new Promise((resolve, reject) => {
        form.validate(valid => {
          if (valid) {
            resolve();
          } else {
            reject();
          }
        });
      });
      this.resultArr.push(result);
    },
    onSubmit() {
      this.$refs.dataFrom.validate(async valid => {
        if (valid) {
          this.resultArr = [];
          this.checkForm(this.$refs.applicantFrom);
          this.$refs.insuredForm && this.$refs.insuredForm.forEach(item => {
            this.checkForm(item);
          });
          Promise.all(this.resultArr).then(async () => {
            var _obj$policyNo;
            this.loading = true;
            this.applicantList = this.applicantList.map(item => {
              if (item.checkResult) {
                delete item.checkResult;
              }
              if (item.display === 'text') {
                var _item$valData;
                item.valData = ((_item$valData = item.valData) === null || _item$valData === void 0 ? void 0 : _item$valData.trim()) || '';
              }
              return item;
            });
            this.insuredList = this.insuredList.map(item => {
              return item.map(item2 => {
                if (item2.checkResult) {
                  delete item2.checkResult;
                }
                if (item2.display === 'text') {
                  var _item2$valData;
                  item2.valData = ((_item2$valData = item2.valData) === null || _item2$valData === void 0 ? void 0 : _item2$valData.trim()) || '';
                }
                return item2;
              });
            });
            const res = await policyVerifyy({
              insuranceId: this.form.insuranceId,
              applicant: this.applicantList,
              insured: this.insuredList
            }).finally(() => {
              this.loading = false;
            });
            this.applicantList = res.applicant;
            this.insuredList = res.insured;
            if (res.isCheck) {
              this.loading = false;
              return false;
            }
            let obj = this.form;
            obj.policyNo = ((_obj$policyNo = obj.policyNo) === null || _obj$policyNo === void 0 ? void 0 : _obj$policyNo.trim()) || '';
            let applicantList = recursionCopy(this.applicantList);
            let insuredList = recursionCopy(this.insuredList);
            applicantList.map(item => {
              if (item.selectarr) {
                delete item.selectarr;
              }
              return item;
            });
            insuredList.map(item => {
              item.map(item2 => {
                if (item2.selectarr) {
                  delete item2.selectarr;
                }
                return item2;
              });
              item;
            });
            obj.applicant = {
              applicantType: this.applicantForm.applicantType,
              list: [applicantList]
            };
            obj.insured = {
              list: insuredList
            };
            obj.policyUrl = this.fileList.map(item => {
              return item.url;
            });
            if (this.attachValue.length) {
              let isError = false;
              this.tableData.forEach(item => {
                if (item.attachPlanId === '-') {
                  isError = true;
                  this.$message.error(this.$t('所选附加险无可用额度'));
                }
              });
              if (isError) {
                this.loading = false;
                return;
              }
              obj.attachInfo = this.tableData;
            }
            if (this.showRate) {
              obj.rate = this.form.rate || 'shortTerm';
            } else {
              delete obj.rate;
            }
            this.savePolicy(obj);
          }, () => {
            this.loading = false;
          });
        }
      });
    },
    savePolicy(obj) {
      //校验通过 请求保存接口
      let result = true;
      this.loading = true;
      addPolicy(obj).then(res => {
        result = false;
        this.loading = false;
        this.$message.success(this.$t('录入成功'));
        this.form = {
          planId: undefined,
          insuranceId: undefined,
          personnelDetails: false
        };
        this.insuranceInfo = {};
        this.$refs.dataFrom.resetFields();
        if (!this.continueState) {
          this.$router.go(-1);
        } else {
          this.fileList = [];
          this.insuredList = [];
          this.applicantList = [];
          this.addInsuredFun();
          this.applicantChange();
        }
      }).finally(() => {
        this.loading = false;
      });
      if (result) {
        this.loading = false;
      }
    },
    selectArea(value, valueName, index, index2) {
      if (index2 != -1) {
        this.$set(this.insuredForm, this.insuredList[index][index2].code + index, valueName);
        this.insuredList[index][index2].valData = valueName;
        this.insuredList[index][index2].defaultValue = value;
      } else {
        this.$set(this.applicantForm, this.applicantList[index].code, valueName);
        this.applicantList[index].valData = valueName;
        this.applicantList[index].defaultValue = value;
      }
    },
    customerChange() {
      applicationResource({
        customerId: this.form.customerId
      }).then(res => {
        this.applicationList = res;
        this.form = {
          customerId: this.form.customerId,
          planId: undefined,
          insuranceId: undefined,
          premiumPrice: undefined,
          startAt: undefined,
          endAt: undefined,
          personnelDetails: false
        };
        this.applicationChange();
      });
    },
    beforeUpload(file) {
      //判断大小
      const isLt50M = file.size / 1024 / 1024 < 50;
      if (!isLt50M) {
        this.$message.warning(this.$t('上传文件大小不能超过50M'));
      }
      return isLt50M;
    },
    handleChange(info) {
      //上传不成功不展示上传的名称
      if (!info.file.status) {
        return;
      }
      if (info.file.status === 'done') {
        console.log(info.file.status, 'info.file.status');
        if (info.file.response.code != 200) {
          this.$message.error(info.file.response.message);
          this.fileList[this.fileList.length - 1].status = 'error';
        }
      }
      let fileList = info.fileList;
      this.fileList = fileList.map(file => {
        if (file.response) {
          file.url = process.env.NODE_ENV === 'production' ? cryptoDecrypt(file.response.data).fileTempUrl : file.response.data.fileTempUrl;
        }
        return file;
      });
    },
    async handlePreview(file) {
      this.isShow = '';
      if (isImage(file.name)) {
        this.isShow = 'image';
      }
      if (isVideo(file.name)) {
        this.isShow = 'video';
      }
      if (file.type == 'application/pdf' || file.type == 'pdf') {
        window.open(file.url);
      } else if (this.isShow === 'image' || this.isShow === 'video') {
        if (!file.url && !file.preview) {
          file.preview = await getBase64(file.originFileObj);
        }
        this.previewSrc = file.url || file.preview;
        this.currentPreviewIndex = this.fileList.indexOf(file);
        this.previewVisible = true;
      }
    }
  }
};